// extracted by mini-css-extract-plugin
export var svgPolygonFill = "b9_jM";
export var svgPolygonFillNone = "b9_jP";
export var svgPolygonStroke = "b9_jN";
export var svgPolygonStrokeThree = "b9_jR";
export var svgPolygonStrokeTwoFive = "b9_jQ";